import angular from 'angular';
import uiRouter from 'angular-ui-router';
import previousLinkComponent from './previousLink.component';

let previousLinkModule = angular.module('previousLink', [
  uiRouter
])

.component('previousLink', previousLinkComponent)

.name;

export default previousLinkModule;
